/** Ссылка привязки сотрудника Битрикс24 (бот «Аналитик PrinTort»): единственный параметр — одноразовый код. */
const BITRIX_LINK_PATH = '/integrations/bitrix/link'

/** Возврат после входа допускается только на локальный экран согласия или страницу привязки Битрикс24. */
export function safeConsentReturnTo(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null
  try {
    const url = new URL(value, 'https://pim.invalid')
    if (url.origin !== 'https://pim.invalid' || url.hash) return null
    if (url.pathname === '/oauth/consent') return `${url.pathname}${url.search}`
    if (url.pathname === BITRIX_LINK_PATH) {
      const keys = [...url.searchParams.keys()]
      const code = url.searchParams.get('code')
      return keys.length === 1 && code && /^[A-Za-z0-9_-]{32,128}$/.test(code) ? `${url.pathname}?code=${code}` : null
    }
    return null
  } catch { return null }
}

const oauthFields = ['client_id', 'redirect_uri', 'response_type', 'scope', 'state', 'code_challenge', 'code_challenge_method', 'resource'] as const

export function readOAuthParams(search: string): Record<string, string> {
  const query = new URLSearchParams(search)
  const params: Record<string, string> = {}
  for (const key of oauthFields) {
    if (query.getAll(key).length > 1) throw new Error('Параметры запроса повторяются. Начните подключение заново.')
    const value = query.get(key)
    if (value !== null) params[key] = value
  }
  return params
}

/** Сервер проверяет allowlist; здесь дополнительно исключаем подмену callback. */
export function verifiedCallback(redirectUrl: string, redirectUri: string): string {
  const expected = new URL(redirectUri)
  const target = new URL(redirectUrl)
  if (!['http:', 'https:'].includes(target.protocol)
    || target.origin !== expected.origin || target.pathname !== expected.pathname
    || target.username || target.password || target.hash) {
    throw new Error('Сервер вернул некорректный адрес возврата.')
  }
  return target.href
}

export function redirectToCallback(redirectUrl: string, redirectUri: string): void {
  window.location.assign(verifiedCallback(redirectUrl, redirectUri))
}
